module.exports = __webpack_public_path__ + "img/kiosk-specifications-fr.3df30bdd.webp";